import makeSlug from "@/utils/makeSlug";

export default function createHrefWithQuery(
  slug: string,
  query: Record<string, string | string[] | undefined>,
) {
  const searchParams = new URLSearchParams();
  for (const [key, value] of Object.entries(query)) {
    if (!value) continue;
    if (Array.isArray(value)) {
      for (const v of value) {
        searchParams.append(key, v);
      }
    } else {
      searchParams.append(key, value);
    }
  }
  return makeSlug(slug) + "?" + searchParams.toString();
}
